module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAAXNSR0IB2cksfwAAACdQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3RL5tQAAAA10Uk5TADAQf5D/YM/QauHigCO9MCkAAABnSURBVHicNc2xDYAwEENRJwVz0F1DxQQ0jJCIiIYmI7AAu7AnubNJdXpS/JHAl1fsF0+r6JV4P5hKsB0zyI4gBwYTg4WDm9D5R+S36YKdRcnxXUnfVDI2ybEZrJCzQs5dob5hUSjhAytAGkSKALa5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/update-alert--exit.png
// module id = 973
// module chunks = 0